/**
* Toggle background scroll
*
* @param {boolean} scroll - Whether to turn on or off the background scroll
*/
export const handleBackgroundScroll = (scroll: boolean) => {
    if(scroll === true){
        document.body.classList.add('modal-open');
    } else {
        document.body.classList.remove('modal-open');
    }
}
